import React from 'react';
import '../css/skeleton.css';
import '../css/normalize.css';
import '../css/components.css';
import { motion } from 'framer-motion';

function Card2(props) {
  const indexStr = String((props.i2 || 0) + 1).padStart(2, '0');

  const variants = {
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.3 + i * 0.1,
        duration: 0.5,
        ease: [0.25, 1, 0.5, 1],
      },
    }),
    hidden: { opacity: 0, y: 30 },
  };

  return (
    <div className="card2-wrapper">
      <motion.div
        className="Card2 industrial-card"
        initial="hidden"
        animate="visible"
        custom={props.i2}
        variants={variants}
      >
        {/* Corner Ticks */}
        <div className="corner-tick top-left">+</div>
        <div className="corner-tick top-right">+</div>
        <div className="corner-tick bottom-left">+</div>
        <div className="corner-tick bottom-right">+</div>

        <div className="card-top-bar">
          <span className="card-index-tag">EXHIBIT // {indexStr}</span>
          <span className="mono-sub">&ldquo;GARMENT_STUDY&rdquo;</span>
        </div>

        <div className="cover2-wrapper">
          <img className="cover2" src={props.cover} alt="Garment Study" />
        </div>

        <div className="card2-meta-footer">
          <span>SPEC: HEAVYWEIGHT COTTON // SAMPLE</span>
          <span className="accent-text">STATUS: ARCHIVED</span>
        </div>
      </motion.div>
    </div>
  );
}

export default Card2;